<template>
    <div>
        <button @click="openModal" class="btn-red">
            {{ ticket.closed_at ? __('Update Resolution') : __('Close Ticket') }}
        </button>

        <Modal :show="showModal" @close="closeModal" max-width="md">
            <div class="p-6">
                <h2 class="text-lg font-medium text-gray-900 mb-4">
                    {{ ticket.closed_at ? __('Update Resolution') : __('Close Ticket') }}
                </h2>

                <div class="space-y-4">
                    <textarea-input
                        v-model="form.resolution"
                        :error="form.errors.resolution"
                        class="w-full"
                        :label="__('Resolution Details *')"
                        required
                        rows="5"
                    />

                    <select-input
                        v-model="form.root_cause_id"
                        :error="form.errors.root_cause_id"
                        class="w-full"
                        :label="__('Root Cause')"
                    >
                        <option value="">{{ __('Select Root Cause') }}</option>
                        <option v-for="cause in rootCauses" :key="cause.id" :value="cause.id">
                            {{ cause.name }}
                        </option>
                    </select-input>

                    <select-input
                        v-model="form.resolution_id"
                        :error="form.errors.resolution_id"
                        class="w-full"
                        :label="__('Resolution Type')"
                    >
                        <option value="">{{ __('Select Resolution Type') }}</option>
                        <option v-for="resolution in resolutions" :key="resolution.id" :value="resolution.id">
                            {{ resolution.name }}
                        </option>
                    </select-input>
                </div>

                <div class="flex justify-end mt-6 space-x-2">
                    <button type="button" @click="closeModal" class="btn-gray">
                        {{ __('Cancel') }}
                    </button>
                    <LoadingButton
                        @click="submit"
                        :loading="form.processing"
                        class="btn-red"
                    >
                        {{ form.processing ? __('Processing...') : (ticket.closed_at ? __('Update') : __('Close Ticket')) }}
                    </LoadingButton>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '@/Shared/Modal';
import TextareaInput from '@/Shared/TextareaInput';
import SelectInput from '@/Shared/SelectInput';
import LoadingButton from '@/Shared/LoadingButton';

export default {
    components: { Modal, TextareaInput, SelectInput, LoadingButton },
    props: {
        ticket: Object,
        rootCauses: Array,
        resolutions: Array
    },
    data() {
        return {
            showModal: false,
            form: this.$inertia.form({
                resolution: this.ticket.resolution || '',
                root_cause_id: this.ticket.root_cause_id || null,
                resolution_id: this.ticket.resolution_id || null
            })
        }
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        submit() {
            this.form.put(route('tickets.close', this.ticket.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.closeModal();
                    this.$emit('closed');
                }
            });
        }
    }
}
</script>
